import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils'

interface QuestionItem {
  question_name: string
  question_id: string
}

type QuestionItemV2 = {
  question_name: string
  question_id: string
  question_content: string
}
type QuestionType = {
  question_type: QuestionItem[]
  question_title: string
}

type QuestionTypeV2 = {
  question_type: QuestionItemV2[]
  category_id: string
  category_name: string
}

type FAQList = {
  list: QuestionType[]
  listV2: QuestionTypeV2[]
}

const initialState = {
  list: null,
  listV2: null,
} as FAQList

export const getFaq = createAsyncThunk<any, any>(
  'getFaq',
  async (arg, store) => {
    return req(
      '/task/get_pengpeng_faq',
      // @ts-ignore
      {...arg},
      store,
      false,
      null
    )
  }
)

export const getPengpengFaqV2 = createAsyncThunk<any, any>(
  'getPengpengFaqV2',
  async (arg, store) => {
    return req(
      '/task/get_pengpeng_faq_v2',
      // @ts-ignore
      {...arg},
      store,
      false,
      null
    )
  }
)

export const reportSlice = createSlice({
  name: 'faq',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFaq.fulfilled, (state, action) => {
      state.list = action.payload.list
    })
    builder.addCase(getPengpengFaqV2.fulfilled, (state, action) => {
      state.listV2 = action.payload.list
    })
  },
})

export default reportSlice.reducer
